<template>
  <div class="help-tooltip">
    <div v-if="videoSrc || videoSrcYoutube"
         class="help-tooltip__media">
      <template v-if="!isShowVideo">
        <picture v-if="src"
                 class="help-tooltip__img">
          <img :src="src"
               :alt="title">
        </picture>
        <button v-if="showPlayBtn"
                type="button"
                class="help-tooltip__video-btn"
                @click.prevent="onShowVideo"
        >
          <BaseSvg name="ico-play-fill"/>
        </button>
      </template>
      <template v-else>
        <iframe v-if="videoSrcYoutube"
                :src="videoSrcYoutube + '?autoplay=1'"
                width="560" height="315"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                class="help-tooltip__video"></iframe>
        <video v-else
               controls
               autoplay
               class="help-tooltip__video">
          <source type="video/webm"
                  :src="videoSrc.webm">
          <source type="video/mp4"
                  :src="videoSrc.main">
        </video>
      </template>
    </div>
    <div v-else-if="number !== undefined"
         class="help-tooltip__media">
      <div class="help-tooltip__media-number">
        <span>{{ number }}</span>
      </div>
    </div>
    <div
      v-else-if="icon"
      class="help-tooltip__media _icon"
      :class="iconWrapClass"
    >
      <BaseSvg :name="icon" width="100%" height="25rem" />
    </div>
    <div v-else
         class="help-tooltip__media">
      <picture v-if="src"
               class="help-tooltip__img">
        <img :src="src"
             :alt="title">
      </picture>
    </div>
    <h3 v-if="title"
        v-html="title"
        class="help-tooltip__title">
    </h3>
    <div v-if="description"
         v-html="description"
         class="help-tooltip__text text">
    </div>
    <button v-if="btn && btn.callBack"
            @click="btn.callBack"
            class="help-tooltip__btn  base-btn  base-btn--small  base-btn--outline-grey">
      {{ btn.text }}
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      number: {
        type: Number
      },
      videoSrc: {
        type: Object
      },
      videoSrcYoutube: {
        type: String
      },
      icon: {
        type: String,
      },
      src: {
        type: String
      },
      title: {
        type: String
      },
      description: {
        type: String
      },
      btn: {
        type: Object
      },
      iconWrapClass: {
        type: [Object, String, Array]
      },
      showPlayBtn: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        isShowVideo: false,
      }
    },
    methods: {
      onShowVideo() {
        this.isShowVideo = true
      },
    }
  }
</script>

<style lang="less">

</style>
